<template>
  <div class="collect-link">
    <div
      v-if="surveyData.status==='published'"
      class="link_wrap"
    >
      <div class="method_a">
        <div class="m_title">
          <span class="strong">方法一</span>
          <span class="text">分享链接</span>
        </div>
        <div class="m_describe">
          可以将您的链接插入网页、邮箱、短信以及线下场景
        </div>
        <el-card class="box-card">
          <el-input
            v-model="link"
            style="width:500px;margin-right:10px;"
            readonly
            placeholder="请输入内容"
          ></el-input>
          <el-button
            v-clipboard="clipOptions"
            plain
            class="plain_primary"
          >复制链接</el-button>
        </el-card>
      </div>
      <div class="method_b">
        <div class="m_title">
          <span class="strong">方法二</span>
          <span class="text">二维码分享</span>
        </div>
        <el-card class="box-card">
          <div class="qrcode">
            <img
              :src="imgurl"
              height="132"
            />
          </div>
          <el-button
            plain
            class="download_btn plain_primary"
            @click="download"
          >下载二维码</el-button>
        </el-card>
      </div>
    </div>
    <no-release
      v-else
      :data="surveyData"
    ></no-release>
  </div>
</template>

<script>
import NoRelease from "./components/no-release";
import qrcode from "qrcode";
export default {
  data() {
    return {
      link: "",
      imgurl: ""
    };
  },
  computed: {
    surveyData() {
      return this.$store.state.survey.surveyBody;
    },
    clipOptions() {
      return {
        value: this.link,
        success: () => {
          this.message("复制成功", "success");
        },
        error: () => {
          this.message("复制失败", "error");
        }
      };
    }
  },
  mounted() {
    const surveyId = this.$route.params.id;
    this.link = `https://yuetu.chingshen.cn/cu/s/${surveyId}`;
    qrcode.toDataURL(this.link).then(res => {
      this.imgurl = res;
    });
  },
  methods: {
    message(msg, status) {
      this.$message({
        type: status,
        center: true,
        message: msg,
        duration: 1500
      });
    },
    download() {
      var alink = document.createElement("a");
      alink.href = this.imgurl;
      alink.download = "qrcode";
      alink.click();
    }
  },
  components: {
    NoRelease
  }
};
</script>

<style lang="less" scoped>
.collect-link {
  padding-top: 50px;
}

.link_wrap {
  width: 650px;
  margin: 0 auto;
}

.m_title {
  font-size: 30px;
  text-align: center;

  .strong {
    color: #1d82fc;
    margin-right: 15px;
  }
}

.m_describe {
  text-align: center;
  margin-top: 20px;
  font-size: 18px;
}

.box-card {
  margin-top: 30px;
}

.method_b {
  margin-top: 50px;

  .el-card__body {
    text-align: center;
    padding: 30px 20px;
  }
}
</style>
